import { alpha } from '@mui/material/styles';
import { DEFAULT_COLORS, THEME_VARIANTS } from './constants';

export const createPalette = (variant, customColors = {}) => {
  const primaryColor = customColors.primary || DEFAULT_COLORS.PRIMARY;
  const secondaryColor = customColors.secondary || DEFAULT_COLORS.SECONDARY;

  const palettes = {
    [THEME_VARIANTS.LIGHT]: {
      mode: 'light',
      common: {
        black: '#000000',
        white: '#ffffff',
      },
      primary: {
        main: primaryColor,
        light: alpha(primaryColor, 0.7),
        dark: alpha(primaryColor, 0.9),
        contrastText: '#ffffff',
      },
      secondary: {
        main: secondaryColor,
        light: alpha(secondaryColor, 0.7),
        dark: alpha(secondaryColor, 0.9),
        contrastText: '#ffffff',
      },
      error: {
        main: '#f44336',
        light: '#e57373',
        dark: '#d32f2f',
        contrastText: '#ffffff',
      },
      warning: {
        main: '#ff9800',
        light: '#ffb74d',
        dark: '#f57c00',
        contrastText: '#ffffff',
      },
      info: {
        main: '#2196f3',
        light: '#64b5f6',
        dark: '#1976d2',
        contrastText: '#ffffff',
      },
      success: {
        main: '#4caf50',
        light: '#81c784',
        dark: '#388e3c',
        contrastText: '#ffffff',
      },
      background: {
        default: '#f0f2f5',
        paper: '#f8f9fa',
      },
      text: {
        primary: '#050315',
        secondary: 'rgba(5, 3, 21, 0.7)',
      },
      divider: 'rgba(5, 3, 21, 0.08)',
      action: {
        hover: alpha(primaryColor, 0.08),
        selected: alpha(primaryColor, 0.12),
        disabled: 'rgba(5, 3, 21, 0.26)',
        disabledBackground: 'rgba(5, 3, 21, 0.12)',
      },
      grey: {
        50: '#fafafa',
        100: '#f5f5f5',
        200: '#eeeeee',
        300: '#e0e0e0',
        400: '#bdbdbd',
        500: '#9e9e9e',
        600: '#757575',
        700: '#616161',
        800: '#424242',
        900: '#212121',
      },
    },

    [THEME_VARIANTS.DARK]: {
      mode: 'dark',
      common: {
        black: '#000000',
        white: '#ffffff',
      },
      primary: {
        main: primaryColor,
        light: alpha(primaryColor, 0.7),
        dark: alpha(primaryColor, 0.9),
        contrastText: '#ffffff',
      },
      secondary: {
        main: secondaryColor,
        light: alpha(secondaryColor, 0.7),
        dark: alpha(secondaryColor, 0.9),
        contrastText: '#ffffff',
      },
      error: {
        main: '#f44336',
        light: '#e57373',
        dark: '#d32f2f',
        contrastText: '#ffffff',
      },
      warning: {
        main: '#ff9800',
        light: '#ffb74d',
        dark: '#f57c00',
        contrastText: '#ffffff',
      },
      info: {
        main: '#2196f3',
        light: '#64b5f6',
        dark: '#1976d2',
        contrastText: '#ffffff',
      },
      success: {
        main: '#4caf50',
        light: '#81c784',
        dark: '#388e3c',
        contrastText: '#ffffff',
      },
      background: {
        default: '#080808',
        paper: '#0d0d0d',
      },
      text: {
        primary: '#ffffff',
        secondary: 'rgba(255, 255, 255, 0.7)',
      },
      divider: 'rgba(255, 255, 255, 0.12)',
      action: {
        hover: alpha('#ffffff', 0.08),
        selected: alpha('#ffffff', 0.12),
        disabled: 'rgba(255, 255, 255, 0.26)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
      },
      grey: {
        50: '#fafafa',
        100: '#f5f5f5',
        200: '#eeeeee',
        300: '#e0e0e0',
        400: '#bdbdbd',
        500: '#9e9e9e',
        600: '#757575',
        700: '#616161',
        800: '#424242',
        900: '#212121',
      },
    },

    [THEME_VARIANTS.PINK]: {
      mode: 'dark',
      common: {
        black: '#000000',
        white: '#ffffff',
      },
      primary: {
        main: '#FF1493',
        light: '#FF69B4',
        dark: '#C71585',
        contrastText: '#FFB6C1',
      },
      secondary: {
        main: '#FF69B4',
        light: '#FFB6C1',
        dark: '#FF1493',
        contrastText: '#FFB6C1',
      },
      error: {
        main: '#f44336',
        light: '#e57373',
        dark: '#d32f2f',
        contrastText: '#ffffff',
      },
      warning: {
        main: '#ff9800',
        light: '#ffb74d',
        dark: '#f57c00',
        contrastText: '#ffffff',
      },
      info: {
        main: '#2196f3',
        light: '#64b5f6',
        dark: '#1976d2',
        contrastText: '#ffffff',
      },
      success: {
        main: '#4caf50',
        light: '#81c784',
        dark: '#388e3c',
        contrastText: '#ffffff',
      },
      background: {
        default: '#1A0011',
        paper: '#260019',
      },
      text: {
        primary: '#FFB6C1',
        secondary: '#FF69B4',
      },
      divider: 'rgba(255, 20, 147, 0.12)',
      action: {
        hover: alpha('#FF1493', 0.08),
        selected: alpha('#FF1493', 0.12),
        disabled: 'rgba(255, 182, 193, 0.26)',
        disabledBackground: 'rgba(255, 182, 193, 0.12)',
      },
      pink: {
        main: '#FF1493',
        light: '#FF69B4',
        dark: '#C71585',
        contrastText: '#FFB6C1',
      },
      grey: {
        50: '#fafafa',
        100: '#f5f5f5',
        200: '#eeeeee',
        300: '#e0e0e0',
        400: '#bdbdbd',
        500: '#9e9e9e',
        600: '#757575',
        700: '#616161',
        800: '#424242',
        900: '#212121',
      },
    },
  };

  return palettes[variant] || palettes[THEME_VARIANTS.LIGHT];
}; 